import dfUn from "../assets/df_un.jpg";
import dfHd from "../assets/df_hd.jpg";
import dfCw from "../assets/df_cw.jpg";
import dfPf from "../assets/df_pf.jpg";
import dfWb from "../assets/df_wb.jpg";

export const VILLAGES = [
    {
        slug: 'unterreichenbach',
        img: dfUn,
        title: 'Unterreichenbach',
        available: true,
        mapX: 36.3 ,
        mapY: 79,
        googlePlayUrl: 'https://play.google.com/store/apps/details?id=de.dorffuchs.unterreichenbach',
        appStoreUrl: 'soon'
    },
    {
        slug: 'calw',
        img: dfCw,
        title: 'Calw',
        available: false,
        mapX: 36.5 ,
        mapY: 81,
        googlePlayUrl: null,
        appStoreUrl: null
    },
    {
        slug: 'pforzheim',
        img: dfPf,
        title: 'Pforzheim',
        available: false,
        mapX: 36.0,
        mapY: 77.4,
        googlePlayUrl: null,
        appStoreUrl: null
    },
    {
        slug: 'heidelberg',
        img: dfHd,
        title: 'Heidelberg',
        available: false,
        mapX: 35.6,
        mapY: 71.0,
        googlePlayUrl: null,
        appStoreUrl: null
    },
    {
        slug: 'bad-wildbad',
        img: dfWb,
        title: 'Bad Wildbad',
        available: false,
        mapX: 40.0,
        mapY: 72.0,
        googlePlayUrl: null,
        appStoreUrl: null
    },
];

export function findVillageBySlug(slug) {
    return VILLAGES.find(v => v.slug === slug) || null;
}

